import React, { useEffect, useState } from 'react';
import { startOfDay, endOfDay } from 'date-fns';

import { getAllIssuedCardLogAPI, getAllUsersAPI } from '../../../../services/api';
import FilterHeader from './filter-header';
import Loader from "../../../../components/loader";
import NavBar from '../../../../components/Navbar';
import Notify from "../../../../components/notify";
import TableBody from "./table-body";
import { InitialFilterHeader } from './initialValues';

const IssuedCardList = () => {
  const [issuedCardLogs, setIssuedCardLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openNotify, setOpenNotify] = useState(false);
  const [page, setPage] = useState(0);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [filter, setFilter] = useState(InitialFilterHeader);

  useEffect(() => {
    const filterValue = mapFilterValues(filter);
    getAllUsers();
    getAllIssuedCardLog(rowsPerPage, page, filterValue);
  }, []);

  const getAllUsers = async () => {
    try {
      const response = await getAllUsersAPI({});
      setUsers(response?.users || []);
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Getting All Users Failed !!' };
      setErrors(errors);
      setOpenNotify(true);
      setLoading(false);
    }
  };

  const getAllIssuedCardLog = async (
    currentRowPerPage,
    currentPage,
    filterPayload
  ) => {
    try {
      const response = await getAllIssuedCardLogAPI({
        limit: currentRowPerPage,
        page: currentPage,
        filter: filterPayload
      });
      setIssuedCardLogs(response?.logs || []);
      setTotalRowCount(response?.count || 0);
      setLoading(false);
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Getting All agent issuance logs failed !!' };
      setErrors(errors);
      setOpenNotify(true);
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const filterValue = mapFilterValues(filter);
    getAllIssuedCardLog(rowsPerPage, newPage, filterValue);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = event.target.value;
    const filterValue = mapFilterValues(filter);
    const newPage = 0;
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    getAllIssuedCardLog(newRowsPerPage, newPage, filterValue);
  };

  const handleFilter = () => {
    // setLoading(true);
    const filterValue = mapFilterValues(filter);
    getAllIssuedCardLog(rowsPerPage, page, filterValue);
  };

  const handleClearFilter = async () => {
    setFilter(InitialFilterHeader);
    const filterValue = mapFilterValues(InitialFilterHeader);
    getAllIssuedCardLog(10, 0, filterValue);
  };

  const mapFilterValues = (fil) => {
    return {
      ...fil,
      startDate: fil.startDate ? startOfDay(fil.startDate) : null,
      endDate: fil.endDate ? endOfDay(fil.endDate) : null,
      environment: fil.environment === 'All' ? '' : fil.environment,
      userId: fil.userId === 'All' ? '' : fil.userId,
      method: fil.method === 'All' ? '' : fil.method,
      result: fil.result === 'All' ? '' : fil.result
    }
  }

  const handleSetFilter = (payload) => {
    setFilter({
      ...filter,
      ...payload
    });
  };

  return (
    <>
      <NavBar />
      <FilterHeader
        filter={filter}
        users={users}
        handleFilter={handleFilter}
        handleSetFilter={handleSetFilter}
        handleClearFilter={handleClearFilter}
      />
      <TableBody
        issuedCardLogs={issuedCardLogs}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        totalRowCount={totalRowCount}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <Loader loading={loading} />
      <Notify
        open={openNotify}
        onClose={() => setOpenNotify(false)}
        errors={errors}
      />
    </>
  );
}

export default IssuedCardList;